/**
 * Whether a rich-text job field carries anything a candidate would see.
 *
 * `<p>&nbsp;</p>` is a routine ATS "empty" field whose entity survives tag stripping,
 * including the zero-padded numeric forms some exporters emit. A literal U+00A0 needs
 * no handling — `trim` already treats it as whitespace.
 */
export function richTextHasContent(value: unknown): boolean {
  return typeof value === "string"
    && value
      .replace(/<[^>]*>/g, "")
      .replace(/&nbsp;|&#x0*a0;|&#0*160;/gi, " ")
      .trim() !== ""
}
